import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-8 md:py-10">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-5">
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">漫画分类</h2>
          <Link
            to="/category/hanman"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200"
          >
            全部分类
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-10 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2.5 p-4 rounded-xl bg-background-100 hover:bg-primary-100/60 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-background-50 group-hover:bg-primary-500 text-foreground-700 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <div className="text-center">
                <span className="block text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors duration-300">
                  {cat.name}
                </span>
                <span className="text-[11px] text-foreground-500">{cat.count}部</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}